/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Col, Row } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './physio-therapist.reducer';

export const PhysioTherapistDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const physioTherapistEntity = useAppSelector(state => state.physioTherapist.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="physioTherapistDetailsHeading">
          <Translate contentKey="tinyMedicRestApp.physioTherapist.detail.title">PhysioTherapist</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.id">Id</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.id}</dd>
          <dt>
            <span id="education">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.education">Education</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.education}</dd>
          <dt>
            <span id="training">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.training">Training</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.training}</dd>
          <dt>
            <span id="experience">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.experience">Experience</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.experience}</dd>
          <dt>
            <span id="achievements">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.achievements">Achievements</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.achievements}</dd>
          <dt>
            <span id="timestampentry">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.timestampentry">Timestampentry</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.timestampentry}</dd>
          <dt>
            <span id="microSec">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.microSec">Micro Sec</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.microSec}</dd>
          <dt>
            <span id="lastupdated">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.lastupdated">Lastupdated</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.lastupdated}</dd>
          <dt>
            <span id="active">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.active">Active</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.active ? 'true' : 'false'}</dd>
          <dt>
            <span id="cursor">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.cursor">Cursor</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.cursor}</dd>
          <dt>
            <span id="name">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.name">Name</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.name}</dd>
          <dt>
            <span id="email">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.email">Email</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.email}</dd>
          <dt>
            <span id="visitCharge">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.visitCharge">Visit Charge</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.visitCharge}</dd>
          <dt>
            <span id="age">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.age">Age</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.age}</dd>
          <dt>
            <span id="gender">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.gender">Gender</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.gender}</dd>
          <dt>
            <span id="mobile">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.mobile">Mobile</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.mobile}</dd>
          <dt>
            <span id="dateOfBirth">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.dateOfBirth">Date Of Birth</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.dateOfBirth}</dd>
          <dt>
            <span id="bloodGroup">
              <Translate contentKey="tinyMedicRestApp.physioTherapist.bloodGroup">Blood Group</Translate>
            </span>
          </dt>
          <dd>{physioTherapistEntity.bloodGroup}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.physioTherapist.tmUser">Tm User</Translate>
          </dt>
          <dd>{physioTherapistEntity.tmUser ? physioTherapistEntity.tmUser.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.physioTherapist.contactCode">Contact Code</Translate>
          </dt>
          <dd>{physioTherapistEntity.contactCode ? physioTherapistEntity.contactCode.id : ''}</dd>
          <dt>
            <Translate contentKey="tinyMedicRestApp.physioTherapist.hospital">Hospital</Translate>
          </dt>
          <dd>{physioTherapistEntity.hospital ? physioTherapistEntity.hospital.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/physio-therapist" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/physio-therapist/${physioTherapistEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default PhysioTherapistDetail;
